// extracted by mini-css-extract-plugin
export default {"btn_facebook":"ButtonShareSocmed_btn_facebook__JwA5s","btn_twitter":"ButtonShareSocmed_btn_twitter__Zd7X0","btn_linkedin":"ButtonShareSocmed_btn_linkedin__+Nb6v"};